
import logo from '../../img/uh_logo_bullet_3.png'
import Link from './elements/link';
import Item from './header/item';

const Footer = () => {
  const y = new Date().getFullYear();
  const commonClasses = `flex items-start flex-col`
  return(
    <footer className="footer pt-1 bg-uhgray">
      <div className='mx-5 my-3 text-uhnavy flex'>
        <div className={`w-1/4 lg:w-1/3 inline-block ${commonClasses}`}>
          <img src={logo} alt="UnitHuman Logo" style={{maxWidth: "60px"}}/>
        </div>
        <div className={`w-1/4 lg:w-1/6 inline-block ${commonClasses}`}>
          <div className='mb-5 font-bold'>Quick Links</div>
          <div className={`mb-3`}>
            <Link
                href="/"
                text="Home"
                className={'text-uhnavy '}
            />
          </div>
          <div className={`mb-3`}>
            <Link
                href="/"
                text="About Us"
                className={'text-uhnavy '}
            />
          </div>
        </div>
        <div className={`w-1/4 lg:w-1/6 inline-block ${commonClasses}`}>
          <div className='mb-5 font-bold'>Legal</div>
          <div className={`mb-3`}>
            <Link
                href="/privacy"
                text="Privacy Policy"
                className={'text-uhnavy'}
            />
          </div>
          <div className={`mb-3`}>
            <Link
                href="/terms"
                text="Terms of Service"
                className={'text-uhnavy '}
            />
          </div>
        </div>
        <div className={`w-1/2 lg:w-1/6 inline-block ${commonClasses}`}>
          <div  className='mb-5 font-bold'>Contact</div>
          <div>info@UnitHuman.co</div>
        </div>
        <div className={`w-1/4 lg:w-1/6 lg hidden lg:inline-block ${commonClasses}`}>
          
        </div>
      </div>
      <div className='mx-5 mb-5 text-uhgray-darkest'>
        ©{y} UnitHuman Inc. All Rights Reserved
      </div>
    </footer>
  )
}

export default Footer;